import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const ListItemService = {
    getAllListItem,
    getListItemById,
    getListItByID
};

async function getAllListItem() {
    const configOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/crm/list-item/getAll/ListItems`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getListItemById(lg_user_id,lg_user_table_id,blockOwners,blockCreator) {
    const configOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/crm/list-item/getTaskAndBlockStatuses?lg_user_id=${lg_user_id}&lg_user_table_id=${lg_user_table_id}&blockOwners=${blockOwners}&blockCreator=${blockCreator}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}


async function getListItByID(id) {
    const configOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/crm/list-item/getLists/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}